module.exports = __webpack_public_path__ + "img/CR07EU.51712072.png";